// A moose, modelled facing +X: a tall dark body on long legs, a humped shoulder,
// a long drooping snout with a dewlap and broad palmate antlers. Ported 1:1 from
// age-of-mcp's classic moose.ts, restoring its leg loop, body composition and
// the palmate-antler side loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.08, 0.04], [0.08, -0.04], [-0.08, 0.04], [-0.08, -0.04]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.009, 0.007, 0.24, 4),
      color: "#2e2218", position: [x!, 0.12, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.07, 0), color: "#3e2e20",
      position: [0, 0.24, 0], scale: [1.7, 1.1, 0.95] },             // body
    { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#3a2a1c",
      position: [0.02, 0.285, 0], scale: [0.9, 1, 1] },              // shoulder hump
    { geometry: new THREE.CylinderGeometry(0.026, 0.03, 0.09, 5), color: "#3e2e20",
      position: [0.11, 0.27, 0], rotation: [0, 0, -0.5] },          // neck
    { geometry: new THREE.BoxGeometry(0.06, 0.04, 0.04), color: "#463423",
      position: [0.165, 0.29, 0] },                                  // long head
    { geometry: new THREE.IcosahedronGeometry(0.016, 0), color: "#2a2018",
      position: [0.2, 0.272, 0] },                                   // bulbous snout
    { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#2a2018",
      position: [0.15, 0.255, 0], scale: [0.6, 1.3, 0.6] },         // dewlap
  );
  // Palmate antlers — a flat blade each side with a few points.
  for (const side of [1, -1]) {
    parts.push(
      { geometry: new THREE.IcosahedronGeometry(0.03, 0), color: "#cdb184",
        position: [0.155, 0.34, side * 0.04], scale: [1.2, 0.25, 1.1] },
      { geometry: new THREE.ConeGeometry(0.006, 0.02, 4), color: "#cdb184",
        position: [0.18, 0.36, side * 0.05] },
      { geometry: new THREE.ConeGeometry(0.006, 0.02, 4), color: "#cdb184",
        position: [0.135, 0.36, side * 0.05] },
    );
  }
  return parts;
}

export const moose = defineModel({
  id: "moose",
  scale: 2.23, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Moose",
  tags: ["creature","moose","low-poly","age-of-mcp","classic"],
  summary: "Low-poly moose.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.18,
  parts: () => partsFor(),
  animations: [],
});
